<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <a-form-model
      layout=""
      :model="formInline"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
      @submit="handleSubmit"
      @submit.native.prevent
    >
      <a-row>
        <a-col :span="12">
          <a-form-model-item
            v-for="(item, index) in Details"
            :key="index"
            :label="item.iconName"
          >
            <a-switch
              :checked="item.isUse === 1 ? true : false"
              @change="onChange(item)"
              checked-children="开启"
              un-checked-children="关闭"
            />
            <a-date-picker
              v-if="item.iconId == 6 && item.isUse == 1"
              show-time
              type="date"
              placeholder="选择关闭时间"
              style="width: 100%;"
            />
            <span></span>
            <!-- <span class="tipspan">tips:开启后各个门店游戏币/彩票统一通用</span> -->
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-button @click="goBack">返回</a-button>
  </div>
</template>

<script>
import { storeFunction, functionEdit } from "@/api/homeApi.js";
import { message } from "ant-design-vue";

// import chooseAnItem from "./chooseAnItem.vue";
export default {
  components: {
    // chooseAnItem,
  },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      formInline: {
        user: "",
        password: "",
      },
      show: false,
      currencyRecord: "",
      Details: [],
    };
  },
  mounted() {
    this.getStoreFunction();
  },
  methods: {
    onChange(item) {
      if (item.isUse === 1) {
        functionEdit({
          iconId: item.iconId,
          isUse: 0,
          shopId: item.shopId,
        }).then((res) => {
          this.getStoreFunction();
          message.success(res.data);
        });
      } else {
        functionEdit({
          iconId: item.iconId,
          isUse: 1,
          shopId: item.shopId,
        }).then((res) => {
          this.getStoreFunction();
          message.success(res.data);
        });
      }
    },
    showtable(show) {
      this.show = show;
    },
    async getStoreFunction() {
      let shopId = this.$route.query.shopId;
      await storeFunction(shopId).then((res) => {
        this.Details = res.data;
        console.log(res.data);
      });
    },
    goBack() {
      this.$router.push("/home/storeManagement/managementHom");
    },
  },
};
</script>

<style>
.tipspan {
  color: red;
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/right/iconControl/iconControl.vue